/**
 * Scroll-Reveal: sanftes Fade-in/Slide-in fuer Sections & Produktkacheln beim Scrollen.
 * Progressive enhancement: Klassen werden ausschliesslich per JS gesetzt, ohne JS bleibt
 * alles normal sichtbar (kein Cumulative-Layout-Shift). Leichtgewichtig, kein Framework.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  // Auf Wunsch (reduzierte Bewegung) keine Animation anwenden, Elemente bleiben sichtbar.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Nur bewusst markierte TIZIANO-Module animieren. Generische Theme-Sections,
  // Produktkarten und Testimonials haben eigene Motion-Logik und duerfen hier
  // nicht nochmals transformiert werden.
  var SELECTORS = '.tz-reveal, [data-tz-reveal]';

  function init() {
    var targets = document.querySelectorAll(SELECTORS);
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    targets.forEach(function (el, index) {
      // Bereits im Viewport sichtbare Elemente nicht verstecken (kein Flackern beim Laden).
      var rect = el.getBoundingClientRect();
      var alreadyVisible = rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
      if (alreadyVisible) return;

      el.classList.add('reveal-init');
      observer.observe(el);
    });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
